import dayjs from 'dayjs'
import axios from 'axios'
import { Loading } from 'element-ui'
import store from '../store/index'

let loading

function startLoading () {
  loading = Loading.service({
    lock: true,
    spinner: 'tt-loading',
    text: '',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}

function endLoading () {
  loading && loading.close()
}
// 初始化数据
export function resetForm (data) {
  var type = Object.prototype.toString.call(data)
  var obj = {
    '[object Number]': 0,
    '[object String]': ''
  }
  // eslint-disable-next-line no-prototype-builtins
  if (obj.hasOwnProperty(type)) {
    data = obj[type]
    return data
  } else {
    for (const key in data) {
      let _type = Object.prototype.toString.call(data[key])
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(_type)) {
        data[key] = obj[_type]
      } else {
        resetForm(data[key])
      }
    }
  }
  return data
}
// 下载
export function downloadFile (url, data) {
  var form = document.createElement('form')
  form.style.display = 'none'
  form.target = ''
  form.id = Date.now()
  form.method = 'post'
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const val = data[key]
      var input = document.createElement('input')
      input.type = 'hidden'
      input.name = key
      input.value = val
      form.appendChild(input)
    }
  }

  var Authorization = document.createElement('input')
  Authorization.type = 'hidden'
  Authorization.name = 'Authorization'
  Authorization.value = store.state.user.token
  form.appendChild(Authorization)
  form.action = `${process.env.ROOT_URL}${url}`
  document.body.appendChild(form)
  form.submit()
  form.remove()
}
export function downloadPlanData (url, params) {
  startLoading()
  axios
    .post(`${process.env.ROOT_URL}${url}`, params, {
      responseType: 'arraybuffer',
      headers: {
        Authorization: store.state.user.token
      }
    })
    .then(function (res) {
      if (res) {
        let blob = new Blob([res.data], {
          type: 'application/vnd.ms-excel;charset=utf-8'
        }) // res就是接口返回的文件流了
        let objectUrl = URL.createObjectURL(blob)
        const elink = document.createElement('a')
        var fileName =
          (res.headers['content-disposition'] || '').split('=') || ''
        fileName = fileName[fileName.length - 1]
        fileName = decodeURI(fileName.replace(/"/g, ''))
        elink.download = fileName // 下载文件名称,
        elink.style.display = 'none'
        elink.href = objectUrl
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href) // 释放URL 对象
        document.body.removeChild(elink)
      }
    }).finally(() => {
      endLoading()
    })
}
// 重组部门树
export function renderTreeData (pid, curNode, data) {
  var child = data.filter(item => {
    return item.parentId === +pid
  })
  if (child.length) {
    curNode.children = child
    child.forEach(item => {
      renderTreeData(item.serviceno, item, data)
    })
  }
}
// 重组部门树结构
export function renderEleTreeData (parentId, curNode, data, pIdKey) {
  var child = data.filter(item => {
    return item[pIdKey || 'parent'] === parentId
  })
  if (child.length) {
    curNode.children = child
    child.forEach(item => {
      renderEleTreeData(item.id, item, data, pIdKey)
    })
  }
}
export function formatEleTreeData (data, nodeNameKey) {
  let arr = []
  data.forEach(o => {
    let s = Object.assign(o, {
      id: o.id,
      name: o[nodeNameKey || 'text'],
      children: o.children ? formatEleTreeData((o.children || []), nodeNameKey) : null,
      iconSkin: 'iconfont tt-e9cb7f icon'
    })
    arr.push(s)
  })
  return arr
}
// 获取三字码
export function getCodeByStr (str) {
  return str
    .match(/\(([a-zA-Z]*)\)/g)
    .join('')
    .match(/[a-zA-Z]+/g)
    .join('')
}
// 身份证获取出生日期
// 代码中的if判断是因为一代身份证是15位，二代身份证是18位。但是现在第一代身份证已经失效了，所以不考虑也是可以的
export function getBirthDay (cardNo) {
  var birthday = ''
  if (cardNo != null && cardNo !== '') {
    if (cardNo.length === 15) {
      birthday = '19' + cardNo.slice(6, 12)
    } else if (cardNo.length === 18) {
      birthday = cardNo.slice(6, 14)
    }
    birthday = birthday.replace(/(.{4})(.{2})/, '$1-$2-')
    // 通过正则表达式来指定输出格式为:1990-01-01
  }
  return birthday
}
// 性别是根据身份证的倒数第二位来判断的，奇数为男生，偶数为女生
export function getSex (cardNo) {
  var sexStr = ''
  if (cardNo) {
    if (parseInt(cardNo.slice(-2, -1)) % 2 === 1) {
      sexStr = 'M'
    } else {
      sexStr = 'F'
    }
  }
  return sexStr
}

// 隐私设置
export function hidenText (val) {
  if (val && store.state.indexStore.accountInfo.preferenceOut.isprivacy === '1') {
    let len = val.length
    let str = ''
    if (len > 11) {
      str = `${val.substring(0, 4)}****${val.substring(val.length - 4)}`
    } else if (len <= 7) {
      str = `${val.substring(0, 1)}****${val.substring(val.length - 1)}`
    } else {
      str = `${val.substring(0, len - 8 || 1)}****${val.substring(
        val.length - 4
      )}`
    }
    return str
  }
  return val
}
export function setLocalStorage (name, value) {
  value.item.expireDate = dayjs()
    .add(1, 'day')
    .valueOf()
  let arr = JSON.parse(getLocalStorage(name)) || []
  for (let index = 0; index < arr.length; index++) {
    const element = arr[index]
    if (element.key === value.key) {
      arr.splice(index, 1)
    }
  }
  arr.push(value)
  if (arr.length) {
    window.localStorage.setItem(name, JSON.stringify(arr))
  }
}
export function getLocalStorage (name) {
  return window.localStorage.getItem(name)
}
export function renderHolText (o) {
  let str = ''
  const {
    // hotelType,
    // hotelSelect,
    overfulfil,
    // hotelIstrueTwo,
    // agreementhotel,
    isHolPersonUnit,
    overlayVal,
    travelHolRules
  } = o
  // let ht = hotelType.split(',') || []
  // let hs = hotelSelect.split(',') || []
  // let l = { 1: '预付酒店', 2: '现付酒店', 3: '担保酒店' }
  // if (ht.length) {
  //   str += '酒店类型：'
  //   ht.forEach((t, ti) => {
  //     str += (ti ? ',' : '') + l[t]
  //   })
  //   str+='<br/>'
  // }
  // let x = { 1: '协议酒店', 2: '其它酒店' }
  // if (hs.length) {
  //   str += '查询范围：'
  //   hs.forEach((t, ti) => {
  //     str += (ti ? ',' : '') + x[t]
  //   })
  //   str+='<br/>'
  // }
  if (overfulfil === '1') {
    str += '员工超额可自行支付<br/>'
  }
  // if (hotelIstrueTwo === '1') {
  //   str += '二次确认<br/>'
  // }
  // let a = { 1: '失效', 2: '记录' }
  // if (agreementhotel !== '0') {
  //   str += `协议酒店优先：${a[agreementhotel]}<br/>`
  // }
  let d = { 1: '不叠加', 0: '标准', 2: '最大值', 3: '最小值', 4: '百分比' }
  isHolPersonUnit && (str += `合住规则：${d[isHolPersonUnit]}`)
  isHolPersonUnit === '4' && (str += `(${overlayVal}%)`)
  str += '<br/>'
  let j = {
    onecity: '一线',
    towcity: '二线',
    threecity: '三线',
    othercity: '其他'
  };
  (travelHolRules || []).forEach(t => {
    str += `<div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">`
    str += `${t.jobName}:`
    for (const k in j) {
      if (Object.hasOwnProperty.call(j, k)) {
        const element = j[k]
        str += `${element}:${t[k] || '---'} `
      }
    }
    str += '</div>'
  })
  return str
}
// 显示城市名or机场名
export function echoCityName (code) {
  return ['PEK', 'SHA', 'CTU'].find(s => s === code)
    ? 'cityCName'
    : 'airportCName'
}



// WEBPACK FOOTER //
// ./src/utils/common.js